import { GameState, Secret } from 'game-logic';
import { BlocksListener } from '../blocks-listener';

export class GameListenerService implements BlocksListener {
  private gameListenerService?: BlocksListener;

  public setGameListener(gameListener: BlocksListener) {
    this.gameListenerService = gameListener;
  }

  onGameLoaded(): void {
    this.gameListenerService?.onGameLoaded();
  }
  onStartGame(): void {
    this.gameListenerService?.onStartGame();
  }
  onScoreChange(score: number): void {
    this.gameListenerService?.onScoreChange(score);
  }
  onMultiplierChange(multiplier: number): void {
    this.gameListenerService?.onMultiplierChange(multiplier);
  }
  onLevelChange(level: number): void {
    this.gameListenerService?.onLevelChange(level);
  }
  onNewMove(moves: string[]): void {
    this.gameListenerService?.onNewMove(moves);
  }
  onGameStateChange(state: GameState): void {
    this.gameListenerService?.onGameStateChange(state);
  }
  onGameComplete(moves: string[], isComplete: boolean): void {
    this.gameListenerService?.onGameComplete(moves, isComplete);
  }
  discloseSecrets(
    indexes: number[],
    gameHash: string,
    disclosedSecrets: number,
    existingDeal: boolean,
  ): Promise<Secret[]> {
    return (
      this.gameListenerService?.discloseSecrets(
        indexes,
        gameHash,
        disclosedSecrets,
        existingDeal,
      ) ?? Promise.resolve([])
    );
  }
}
